/* istanbul ignore next */
export { default } from './OutOfStockDialog';
